import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { Injectable } from '@angular/core';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { environment } from 'src/environments/environment';
import { FormDataService } from '../base-data-services/form-data.service';
import { MentorFeedbackModel } from 'common/models/page-models/mentor-feedback/mentor-feedback-data-model';

@Injectable({
  providedIn: 'root',
})
export class MentorFeedbackDataService extends FormDataService<MentorFeedbackModel> {
  constructor(apiService: SmApiService, protected override ss: SystemService) {
    super(API_URL.submitMentorFeedback, apiService, ss);
  }

  createInstance(): MentorFeedbackModel {
    return new MentorFeedbackModel();
  }

//   override getUpdatePayload(data: any) {
//     return {};
//   }

  getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.getStudentListForMentor,
      method: API_METHODS.post,
    };
    return edit;
  }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    dataModel.studentsList = response['details'];
    return dataModel;
  }

  override getUpdateUrl(data = null) {
    return API_URL.submitMentorFeedback;
  }

  override getUpdatePayload(data) {
  
    const payload = {
      token: data.transferData.replace(/ /g, '+')
    };

    return payload;
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
        
      const transformedPayload:any = {
        feedbackQuestionResponse: [],
      };
      for (const key in model) {
        if (
          model.hasOwnProperty(key) 
        ) {
        if (key === "selectStatus") {
          
          transformedPayload.internshipStatusByMentor = model[key];
        } 
        else if(key === "selectStudent"){
          transformedPayload.internshipMasterId = model[key];
        }
        else if(!isNaN(Number(key))) {
          transformedPayload.feedbackQuestionResponse.push({
            questionId: parseInt(key, 10), 
            answer: Array.isArray(model[key])
              ? model[key].join(", ") 
              : String(model[key]),
          });
        }
        }
      }
      resolve(transformedPayload);
    });
  }
}
